import React from "react";
import api from './../../../services/api';
import "./../../../pages/Representante_Instituição/Tela_RI_Solicitar_Consulta";
import { user_token } from "../../../services/Auth";
import { withRouter } from 'react-router-dom';
import { Collapse } from "react-collapse";

import { agent } from '../../../services/api';
let apiAgent = new agent();


var token = localStorage.getItem(user_token);
//var _id = localStorage.getItem("id_agent");


class Form_RI_SolicitarConsulta extends React.Component {

    componentDidMount() {
        const { id } = this.props.user_id;
        console.log(localStorage.getItem("id_agent"));
        localStorage.setItem('user_id', id);

    }


    constructor() {
        super();
        this.state = {

            refusal_notes: "",
            agent_id: "",
            appointment_agent: "",
            user_id: "",
            professional_id: "",
            appointment_date:[],
            appointment_period: "",
            appointment_purpose: "",
            appointment_type: "",
            date: "",
            medical_appointment_type: "",
            notes: "",
            possible_date: [],
            status: "Pendente",
            prescription: "",
            medical_note: "",
            updatedAt: [],
            createdAt: "",
            monitoration_record: {
                date: "",
                anamnese: "",
                referrals: "",
                medications_in_use: "",
                diagnosis: "",
                conduct: "",
                life_habits: {
                    physical_activity: true,
                    smoking: true,
                    smoking_amount: "",
                    alocoholism: true,
                    alcoholism_amount: "",
                    surgery: ""
                }
            }


        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleSelect_at = this.handleSelect_at.bind(this);
        this.handleSelect_ap = this.handleSelect_ap.bind(this);
        this.handleSelect_ms = this.handleSelect_ms.bind(this);

    }

    handleSelect_at(event) {
        this.setState({ appointment_type: event.target.value });
    }

    handleSelect_ap(event) {
        this.setState({ appointment_period: event.target.value });
    }

    handleSelect_ms(event) {
        this.setState({ medical_appointment_type: event.target.value });
    }

    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    handleSelect(event) {
        this.setState({ instituction_id: event.target.value });
    }



    _collapseID(open) {
        if (open === "Outra") {
            return true;
        }
        else {
            return false;
        }
    };

    _collapseType(open) {
        if (open === "Outra") {
            return true;
        }
        else {
            return false;
        }
    };

    _collapseMedica(open) {
        if (open === "Consulta Medica") {
            return true;
        }
        else {
            return false;
        }
    };

    _handleChangeCheckbox = (event) => {
        if (event.target.name === 'matutino') {
            this.setState({
                [event.target.name]: !this.state.matutino
            })
        }
        if (event.target.name === 'vespertino') {
            this.setState({
                [event.target.name]: !this.state.vespertino
            })
        }
        if (event.target.name === 'noturno') {
            this.setState({
                [event.target.name]: !this.state.noturno
            })
        }
        this.generatePeriod(this.state.matutino, this.state.vespertino, this.state.noturno)
    };


    generatePeriod(matutino, vespertino, noturno) {
        this.setState({
            appointment_period: matutino + "_" + vespertino + "_" + noturno
        })
        return
    }
    _handleSubmit = evt => {
        evt.preventDefault();
        const exam = {

            agent_id: localStorage.getItem("id_agent"),
            user_id: localStorage.getItem("user_id"),
            appointment_agent: this.state.appointment_agent,
            refusal_notes: this.state.refusal_notes,
            professional_id: this.state.professional_id,
            appointment_date: this.state.appointment_date,
            appointment_period: this.state.appointment_period,
            appointment_purpose: this.state.appointment_purpose,
            appointment_type: this.state.appointment_type,
            createdAt: this.state.createdAt,
            updatedAt: this.state.updatedAt,
            date: this.state.date,
            medical_appointment_type: this.state.medical_appointment_type,
            notes: this.state.notes,
            possible_date: this.state.possible_date,
            status: this.state.status,
            prescription: this.state.prescription,
            medical_note: this.state.medical_note,
            monitoration_record: this.state.monitoration_record = {
                date: this.state.monitoration_record.date,
                anamnese: this.state.monitoration_record.anamnese,
                referrals: this.state.monitoration_record.referrals,
                medications_in_use: this.state.monitoration_record.medications_in_use,
                diagnosis: this.state.monitoration_record.diagnosis,
                conduct: this.state.monitoration_record.conduct,
                life_habits: this.state.monitoration_record.life_habits,
            },

        }

        console.log(JSON.stringify(exam))
        //api.post(`/exam`, exam, { headers: { 'x-access-token': token } })
        apiAgent.createExam(exam)
            .then(res => {
                console.log(res);
                console.log(res.data);
                alert("Consulta Solicitada com sucesso! Retorne para o Painel!");
                this.props.history.push("/RI_Painel");
            })

    }

    render() {
        return (
            <>
                <div id="collapsed-Solicitar">
                    <form onSubmit={this._handleSubmit} id="RI-Solicitar-Form">
                        <h1 id="tittle-forms-cme">Formulário de Consulta</h1>
                        <br></br>

                        <p id="RI-Title-Solicitar">Insira o nome do servidor que está solicitando a consulta</p>
                        <input name="appointment_agent" onChange={this.handleChange} placeholder="Insira o nome completo:" type="text" id="RI-Solicitar-Forms" required />

                        <p id="RI-Title-Solicitar">Qual o motivo da consulta?</p>
                        <input name="appointment_purpose" onChange={this.handleChange} placeholder="Insira o motivo da consulta:" type="text" id="RI-Solicitar-Forms" required />

                        <p id="RI-Title-Cadastro-Paciente" >Qual é o tipo de consulta desejada?</p>
                        <select value={this.state.appointment_type} onChange={this.handleSelect_at} id="RI-Solicitar-Forms" required>
                            <option></option>
                            <option value='Medicina'>Consulta médica</option>
                            <option value='Psicologia'>Consulta de psicologia</option>
                            <option value='Fisioterapia'>Consulta de fisioterapia</option>
                            <option value='Odontologia'>Consulta de odontologia</option>
                            <option value='Enfermagem'>Consulta de enfermagem</option>
                            <option value='Nutrição'>Consulta de nutrição</option>
                        </select>
                        <Collapse isOpened={this.state.appointment_type === "Medicina"}>
                            <div>
                                <p id="RI-Title-Cadastro-Paciente" >Especialidade Médica(Caso você tenha selecionado "Consulta médica" no item anteriror selecione uma das opções)</p>
                            </div>
                            <select value={this.state.medical_appointment_type} onChange={this.handleSelect_ms} id="RI-Solicitar-Forms">
                                <option></option>
                                <option value='Acupuntura'>Acupuntura</option>
                                <option value='Alergia e imunologia'>Alergia e imunologia</option>
                                <option value='Anestesiologia'>Anestesiologia</option>
                                <option value='Angiologia'>Angiologia</option>
                                <option value='Cardiologia'>Cardiologia</option>
                                <option value='Cirurgia cardiovascular'>Cirurgia cardiovascular</option>
                                <option value='Cirurgia da mão'>Cirurgia da mão</option>
                                <option value='Cirurgia de cabeça e pescoço'>Cirurgia de cabeça e pescoço</option>
                                <option value='Cirurgia do aparelho digestivo'>Cirurgia do aparelho digestivo</option>
                                <option value='Cirurgia geral'>Cirurgia geral</option>
                                <option value='Cirurgia oncológica'>Cirurgia oncológica</option>
                                <option value='Cirurgia pediátrica'>Cirurgia pediátrica</option>
                                <option value='Cirurgia plástica'>Cirurgia plástica</option>
                                <option value='Cirurgia torácica'>Cirurgia torácica</option>
                                <option value='Cirurgia vascular'>Cirurgia vascular</option>
                                <option value='Clínica médica'>Clínica médica</option>
                                <option value='Coloproctologia'>Coloproctologia</option>
                                <option value='Dermatologia'>Dermatologia</option>
                                <option value='Endocrinologia e metabologia'>Endocrinologia e metabologia</option>
                                <option value='Endoscopia'>Endoscopia</option>
                                <option value='Gastroenterologia'>Gastroenterologia</option>
                                <option value='Genética médica'>Genética médica</option>
                                <option value='Geriatria'>Geriatria</option>
                                <option value='Ginecologia e obstetrícia'>Ginecologia e obstetrícia</option>
                                <option value='Hematologia e hemoterapia'>Hematologia e hemoterapia</option>
                                <option value='Homeopatia'>Homeopatia</option>
                                <option value='Infectologia'>Infectologia</option>
                                <option value='Mastologia'>Mastologia</option>
                                <option value='Medicina de emergência'>Medicina de emergência</option>
                                <option value='Medicina de família e comunidade'>Medicina de família e comunidade</option>
                                <option value='Medicina do trabalho'>Medicina do trabalho</option>
                                <option value='Medicina de tráfego'>Medicina de tráfego</option>
                                <option value='Medicina esportiva'>Medicina esportiva</option>
                                <option value='Medicina física e reabilitação'>Medicina física e reabilitação</option>
                                <option value='Medicina intensiva'>Medicina intensiva</option>
                                <option value='Medicina legal e perícia médica'>Medicina legal e perícia médica</option>
                                <option value='Medicina nuclear'>Medicina nuclear</option>
                                <option value='Medicina preventiva e social'>Medicina preventiva e social</option>
                                <option value='Nefrologia'>Nefrologia</option>
                                <option value='Neurocirurgia'>Neurocirurgia</option>
                                <option value='Neurologia'>Neurologia</option>
                                <option value='Nutrologia'>Nutrologia</option>
                                <option value='Oftalmologia'>Oftalmologia</option>
                                <option value='Oncologia clínica'>Oncologia clínica</option>
                                <option value='Ortopedia e traumatologia'>Ortopedia e traumatologia</option>
                                <option value='Otorrinolaringologia'>Otorrinolaringologia</option>
                                <option value='Patologia'>Patologia</option>
                                <option value='Patologia clínica/medicina laboratorial'>Patologia clínica/medicina laboratorial</option>
                                <option value='Pediatria'>Pediatria</option>
                                <option value='Pneumologia'>Pneumologia</option>
                                <option value='Psiquiatria'>Psiquiatria</option>
                                <option value='Radiologia e diagnóstico por imagem'>Radiologia e diagnóstico por imagem</option>
                                <option value='Radioterapia'>Radioterapia</option>
                                <option value='Reumatologia'>Reumatologia</option>
                                <option value='Urologia'>Urologia</option>
                            </select>
                        </Collapse>
                        <p id="RI-Title-Solicitar">Período disponível para consulta</p>
                        <select value={this.state.appointment_period} onChange={this.handleSelect_ap} id="RI-Solicitar-Forms" required>
                            <option></option>
                            <option value='Matutino'>Matutino</option>
                            <option value='Vespertino'>Vespertino</option>
                            <option value='Noturno'>Noturno</option>
                        </select>

                        <p id="RI-Title-Solicitar">Notas</p>
                        <textarea name="notes" onChange={this.handleChange} placeholder="Insira: " type="text" id="RI-Cadastro" />

                        <div style={{ display: 'flex', justifyContent: "center" }}>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <button onClick={() => this._handleSubmit} id="submit-RI-Solicitar">Enviar</button>
                            </div>
                        </div>

                    </form>
                </div>
            </>
        );
    };
}
export default withRouter(Form_RI_SolicitarConsulta);